import {
  BlockStack,
  Card,
  InlineStack,
  ResourceItem,
  ResourceList,
  Spinner,
  Text,
} from "@shopify/polaris";
import { AxiosInstance } from "axios";
import { useEffect, useState } from "react";
import { baseType } from "./hooks/base";
import { t } from "../query/share";
import { themeAppId } from "../query/env";
import { useAppBridge } from "@shopify/app-bridge-react";

export type themesType = {
  id: number;
  name: string;
  created_at: string;
  updated_at: string;
  role: string;
  theme_store_id: number;
  previewable: boolean;
  processing: boolean;
  admin_graphql_api_id: string;
};

const OnlineStore = (
  props: { authAxios: AxiosInstance } & baseType & {
      themes: themesType[];
      setThemes: React.Dispatch<React.SetStateAction<themesType[]>>;
    }
) => {
  const { authAxios, themes, setThemes, base } = props;
  const shopify = useAppBridge();
  const [loading, setLoading] = useState(true);

  const getTheme = async () => {
    const result = await authAxios.post("/api/themes", { shop: base.shop });
    if (result.data?.themes) {
      setThemes(result.data.themes);
    }
    setLoading(false);
  };

  useEffect(() => {
    themes.length ? setLoading(false) : getTheme();
  }, []);

  if (loading)
    return (
      <Card>
        <InlineStack gap="200">
          <div style={{ width: 200 }}>
            <Spinner />
          </div>
        </InlineStack>
      </Card>
    );

  return (
    <Card>
      <BlockStack gap="200">
        <Text as="p" tone="subdued">
          {t(
            `テーマを開いて "保存" を押してください。`,
            `Open the theme and press 'Save'.`
          )}
        </Text>
        <ResourceList
          resourceName={{
            singular: t("テーマ", "Theme"),
            plural: t("テーマ", "Themes"),
          }}
          items={themes}
          renderItem={(item) => {
            const { id, name } = item;
            const url = `https://admin.shopify.com/store/${shopify.config.shop.replace(".myshopify.com", "")}/themes/${id}/editor?context=apps&template=index&activateAppId=${themeAppId}/term-of-use-1988`;
            return (
              <ResourceItem id={id.toString()} url={url} external>
                <Text variant="bodyMd" fontWeight="bold" as="h3">
                  {name}
                </Text>
              </ResourceItem>
            );
          }}
        />
      </BlockStack>
    </Card>
  );
};

export default OnlineStore;
